import React from "react";
import "../App.css";
import SiteNav from "../components/SiteNav";
import usePageMeta from "../hooks/usePageMeta";

function NotFound() {
  usePageMeta({
    title: "Page Not Found | FindlayChryslers.com",
    description:
      "The requested page could not be found. Use the navigation to return to the main consumer report or buyer guide.",
    noindex: true,
  });

  return (
    <>
      <SiteNav />
      <div className="container py-5">
        <div className="text-center">
          <p className="text-uppercase fw-bold text-muted mb-2">404</p>
          <h1 className="h3">Page Not Found</h1>
          <p className="lead">
            The route you requested does not exist. Use the links below to get
            back to a published page.
          </p>
          <div className="d-flex flex-wrap justify-content-center gap-3 mt-4">
            <a href="/" className="btn btn-primary">
              Home
            </a>
            <a href="/guide" className="btn btn-outline-primary">
              Buyer Guide
            </a>
            <a href="/legal" className="btn btn-outline-primary">
              Legal Resources
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default NotFound;
